import styled from 'styled-components';

const MarginAuto = styled.div`
    margin: auto;
`;

export default MarginAuto;
